// extracted by mini-css-extract-plugin
export var activeDot = "_a1-c";
export var buttonContainer = "_a1-9";
export var channelButton = "_a1-a";
export var clickable = "_a1-d";
export var content = "_a1-0";
export var contentFull = "_a1-2";
export var contentThird = "_a1-1";
export var contentWrapper = "_a1-7";
export var description = "_a1-5";
export var heightShort = "_a1-f";
export var image = "_a1-3";
export var imageContainer = "_a1-4";
export var selectButton = "_a1-e";
export var spinnerContainer = "_a1-b";
export var titleContent = "_a1-8";
export var titleWrapper = "_a1-6";